// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Styles from "../../Styles.bs.js";
import * as RimbleUi from "rimble-ui";

function EmailSignup(Props) {
  return React.createElement("div", {
              className: Styles.horizantalBlueTile,
              id: "signup"
            }, React.createElement(RimbleUi.Box, {
                  children: React.createElement(RimbleUi.Flex, {
                        children: null,
                        flexWrap: "wrap",
                        alignItems: "center",
                        className: Styles.floatingSignupBoxInner
                      }, React.createElement(RimbleUi.Box, {
                            children: null,
                            width: [
                              1,
                              1,
                              0.4
                            ],
                            className: Styles.emailTextBox
                          }, React.createElement("p", {
                                className: Styles.emailSignupHeader
                              }, React.createElement("strong", undefined, "Want to stay in the loop?")), React.createElement("span", undefined, "Sign up for our newsletter"), React.createElement("br", undefined), React.createElement("br", undefined)), React.createElement(RimbleUi.Box, {
                            children: React.createElement(RimbleUi.Form, {
                                  children: React.createElement(RimbleUi.Flex, {
                                        children: null,
                                        flexWrap: "wrap"
                                      }, React.createElement(RimbleUi.Box, {
                                            children: React.createElement(RimbleUi.Form.Input, {
                                                  type: "email",
                                                  name: "EMAIL",
                                                  onChange: (function (e) {
                                                      return Curry._1(e.target.parentNode.classList.add, "was-validated");
                                                    }),
                                                  width: 1
                                                }),
                                            width: [
                                              1,
                                              0.6
                                            ],
                                            className: Styles.inputElements
                                          }), React.createElement(RimbleUi.Box, {
                                            children: React.createElement(RimbleUi.Button, {
                                                  children: "Submit",
                                                  width: 1
                                                }),
                                            width: [
                                              1,
                                              0.4
                                            ],
                                            className: Styles.inputElements
                                          })),
                                  action: "https://world.us20.list-manage.com/subscribe/post?u=11056167825e6c3d276b0a362&id=66d23199dd",
                                  method: "post"
                                }),
                            width: [
                              1,
                              1,
                              0.55
                            ]
                          })),
                  className: Styles.floatingSignupBox
                }));
}

var gorillaOnVine = "/img/wildcardsimages/gorilla-on-vine.png";

var make = EmailSignup;

export {
  gorillaOnVine ,
  make ,
  
}
/* react Not a pure module */
